import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { AppState } from '~src/app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { callFavoritesReorder } from '~src/spacesPlatform/actions/CallFavoritesReorder';
import { clearSpaceContentCountsAction } from '~src/spacesPlatform/actions/ContentCountsActions';
import { showContentTypes } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import {
  selectCurrentlyApplicableContentTypes,
  selectDefaultContentTypeFilterValues,
} from '~src/spacesPlatform/selectors/ContentFilterSelectors';

import {
  FavoritesSpace,
  FavoritesSpaceDispatchProps,
  FavoritesSpaceOwnProps,
  FavoritesSpaceStateProps,
} from './FavoritesSpace';

const mapStateToProps: MapStateToProps<FavoritesSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<FavoritesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  requestSpaceContents,
  clearContentCounts: clearSpaceContentCountsAction,
  callFavoritesReorder: callFavoritesReorder
}, dispatch);

export const ConnectedFavoritesSpace: React.ComponentClass<FavoritesSpaceOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(FavoritesSpace);
